<script>
import { defineComponent } from "vue";

import { MatomoHelper } from "@/helpers";
import { MatomoEventAction, MatomoEventCategory } from "@/types";

import SearchInfoBox from "./SearchInfoBox.vue";

export default defineComponent({
  components: {
    SearchInfoBox
  },
  props: {
    oldSearchDirection: {
      type: String,
      default: undefined
    },
    searchDirection: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dismissed: false
    };
  },
  computed: {
    open() {
      MatomoHelper.sendEvent(
        MatomoEventCategory.Search,
        MatomoEventAction.ChangeLanguageDirection,
        "Automatic change of language direction"
      );

      if (!this.oldSearchDirection) {
        return false;
      }

      return !this.dismissed;
    }
  }
});
</script>

<template>
  <SearchInfoBox v-if="open" class="direction-switch-info-box" @close="dismissed = true">
    <i18n-t keypath="article.directionSwitchBoxInfo.text">
      <template #from>
        <span
          class="direction-switch-info-box__prominent-text direction-switch-info-box__prominent-text--from"
        >
          <!-- eslint-disable-next-line @intlify/vue-i18n/no-dynamic-keys -->
          {{ $t(`searchBar.searchDirections.${oldSearchDirection}.buttonLabel`) }}
        </span>
      </template>
      <template #to>
        <span
          class="direction-switch-info-box__prominent-text direction-switch-info-box__prominent-text--to"
        >
          <!-- eslint-disable-next-line @intlify/vue-i18n/no-dynamic-keys -->
          {{ $t(`searchBar.searchDirections.${searchDirection}.buttonLabel`) }}
        </span>
      </template>
    </i18n-t>
  </SearchInfoBox>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.direction-switch-info-box {
  &__prominent-text {
    padding: 0 5px;
    font-weight: 700;

    &--from {
      color: rgb(@theme-colors[@secondary][base]);
    }

    &--to {
      color: rgb(@theme-colors[@primary][base]);
    }
  }
}
</style>
